import { customElement, property } from 'lit/decorators';
import { css, html, LitElement, nothing } from 'lit';
import '@carbon/web-components/es/components/modal';
import { PropertyValues } from '@lit/reactive-element';
import { googleApi } from './googleApi';
import Debug from 'debug';
import pdqDataBroker from '../services/PdqDataBroker';
import { blobCache } from '../services/BlobCache';

const log = Debug('pdq:google:PdqGoogleFileRequest');

@customElement('pdq-google-file-request')
export class PdqGoogleFileRequest extends LitElement {
  @property({ type: String })
  fileId: string = '';

  @property({ type: String })
  alt: string = 'media'

  @property({ type: String })
  table: string = ''

  @property({ type: String })
  index: string|undefined = undefined

  @property({ type: Number })
  expires = 1000 * 60 * 60 * 24 * 20; // 90 day

  static styles = css``;

  render() {
    return nothing;
  }

  updated(changedProperties: PropertyValues) {
    log('updated');
    this.updateFileAsRequired();
  }

  firstUpdated() {
    log('firstUpdated');
    this.updateFileAsRequired();
  }

  private lastLoginKey = ''
  private async updateFileAsRequired() {
    if (this.fileId && this.table) {
      const loginKey =  this.fileId + this.table
      if (this.lastLoginKey === loginKey)
        return
      this.lastLoginKey = loginKey
      log(`loading file from google ${this.fileId}`)
      const meta = await blobCache.get(`google-file-${this.fileId}`,
        () => googleApi.getFileContent(this.fileId, this.alt) as Promise<Blob>,
        this.expires);

      const file = meta.blob;
      if (file && this.table && file instanceof Blob) {
        log(`updating datasource[${this.table}] with file ${this.fileId}`);
        try {
          const json = await blobToJson(file!);
          log(json)
          await pdqDataBroker.updateDataSource(this.table, [json], this.index);
        } catch (ex) {
          log(`error updating datasource[${this.table}] with file ${this.fileId} ${ex}`)
        }
      }
    } else {
      log('ignoring changes, missing fileId or table')
    }
  }
}
const blobToJson = (blob: Blob): Promise<any> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      try {
        const json = JSON.parse(reader.result as string);
        resolve(json);
      } catch (error) {
        reject(error);
      }
    };
    reader.onerror = () => reject(reader.error);
    reader.readAsText(blob);
  });
};